//dependencies
import { ModelBase } from "@shoothill/core";
import { makeObservable, observable } from "mobx";
import moment from "moment";
import { AddStudentModel } from "./AddStudent/AddStudentModel";
import { startOfDay } from "date-fns";
import { MentorStudentRotaResponse } from "./AddStudent/EndPoints/GETMentorStudentRotaByIdEndpoint";

export class WeeklyRotaDetailModel extends ModelBase<WeeklyRotaDetailModel> {
    public mentorAvailability = [];
    public rotaId: Guid = null;
    public currentDate = moment();
    public startOfWeek = this.currentDate.startOf("isoWeek");
    public formattedStartOfWeek = this.startOfWeek.format("MM-DD-YYYY");
    public startDate: Date | string = startOfDay(new Date()).toISOString();

    public addStudentModel: AddStudentModel = new AddStudentModel();
    public leftStudentSession: any = [];
    public studentList: any = [];
    public studentRota: StudentRota = new StudentRota();

    constructor() {
        super();
        makeObservable(this, {
            rotaId: observable,
            startDate: observable,
            addStudentModel: observable,
            leftStudentSession: observable,
            studentRota: observable,
            studentList: observable,
            mentorAvailability: observable,
        });
    }
}

export class StudentRota extends ModelBase<StudentRota> {
    public studentId: string = "";
    public studentName: string = "";
    public mentorId: Guid = "";
    public mentorName: string = "";
    public sessionStatusId: string = "";
    public studentSessionId: string = "";
    public sessionStatusName: string = "";
    public sessionDate: string = "";
    public sessionStartTime: string = "";
    public sessionEndTime: string = "";
    public didAttend: boolean = false;
    public reportIncident: boolean = false;

    public pickupAddressTitle: string = "";
    public pickupAddressLine1: string = "";
    public pickupAddressLine2: string = "";
    public pickupCity: string = "";
    public pickupPostcode: string = "";

    public dropAddAddressTitle: string = "";
    public dropAddAddressLine1: string = "";
    public dropAddAddressLine2: string = "";
    public dropAddCity: string = "";
    public dropAddPostcode: string = "";

    public id: string = "";

    public fromResponse(response: MentorStudentRotaResponse): void {
        this.studentId = response.studentId ?? "";
        this.studentName = response.studentName;
        this.mentorId = response.mentorId;
        this.mentorName = response.mentorName;
        this.sessionStatusId = response.sessionStatusId;
        this.studentSessionId = response.studentSessionId;
        this.sessionStatusName = response.sessionStatusName;
        this.sessionDate = response.sessionDate;
        this.sessionStartTime = response.sessionStartTime;
        this.sessionEndTime = response.sessionEndTime;
        this.didAttend = response.didAttend;
        this.reportIncident = response.reportIncident;
        this.pickupAddressTitle = response.pickupAddressTitle;
        this.pickupAddressLine1 = response.pickupAddressLine1;
        this.pickupAddressLine2 = response.pickupAddressLine2;
        this.pickupCity = response.pickupCity;
        this.pickupPostcode = response.pickupPostcode;
        this.dropAddAddressTitle = response.dropAddAddressTitle;
        this.dropAddAddressLine1 = response.dropAddAddressLine1;
        this.dropAddAddressLine2 = response.dropAddAddressLine2;
        this.dropAddCity = response.dropAddCity;
        this.dropAddPostcode = response.dropAddPostcode;
        this.id = response.id;
    }

    constructor() {
        super();
        makeObservable(this, {
            studentId: observable,
            studentName: observable,
            mentorId: observable,
            mentorName: observable,
            sessionStatusId: observable,
            studentSessionId: observable,
            sessionStatusName: observable,
            sessionDate: observable,
            sessionStartTime: observable,
            sessionEndTime: observable,
            didAttend: observable,
            reportIncident: observable,

            pickupAddressTitle: observable,
            pickupAddressLine1: observable,
            pickupAddressLine2: observable,
            pickupCity: observable,
            pickupPostcode: observable,

            dropAddAddressTitle: observable,
            dropAddAddressLine1: observable,
            dropAddAddressLine2: observable,
            dropAddCity: observable,
            dropAddPostcode: observable,
        });
    }
}
